export default "__VITE_ASSET__Jmi93Z0j__"